module.exports = __webpack_public_path__ + "static/img/hhq.a97bfe00.svg";